export const queryKeys = {
  assets: {
    all: () => ["admin", "assets"] as const,
    byCategory: (categoryId: string) => ["admin", "assets", categoryId] as const,
  },
  categories: {
    all: () => ["admin", "categories"] as const,
  },
  users: {
    all: () => ["admin", "users"] as const,
    detail: (id: string) => ["admin", "users", id] as const,
  },
  orders: {
    all: () => ["admin", "orders"] as const,
    detail: (id: string) => ["admin", "orders", id] as const,
  },
  payments: {
    all: () => ["admin", "payments"] as const,
  },
  products: {
    all: () => ["admin", "products"] as const,
    detail: (id: string) => ["admin", "products", id] as const,
  },
  discounts: {
    all: () => ["admin", "discounts"] as const,
    detail: (id: string) => ["admin", "discounts", id] as const,
    usages: (id: string) => ["admin", "discounts", id, "usages"] as const,
  },
  catalog: {
    all: () => ["admin", "catalog"] as const,
    detail: (id: string) => ["admin", "catalog", id] as const,
  },
  renderQueue: {
    all: () => ["admin", "renderQueue"] as const,
    stats: () => ["admin", "renderQueue", "stats"] as const,
    detail: (id: string) => ["admin", "renderQueue", id] as const,
  },
  paymentReconciliation: {
    all: () => ["admin", "paymentReconciliation"] as const,
    stats: () => ["admin", "paymentReconciliation", "stats"] as const,
    events: () => ["admin", "paymentReconciliation", "events"] as const,
  },
} as const;
